import React from "react";
import { Steps } from "antd";
import "./app_steps2.css";

class AppSteps extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lastValue: 0,
        };
    }

    propTitle() {
        return this.props.title;
    }

    propDirection() {
        return this.props.direction;
    }
    propCurrent() {
        return this.props.current;
    }

    render() {
        return (
            <div className="app-steps_container w-100 ant-steps-item-finish">
                <div className="app-steps-title">{this.propTitle() || ""}</div>
                <Steps
                    className={'my-stepper'}
                    direction={this.propDirection()}
                    current={this.propCurrent()}
                    items={this.props.items}
                />
            </div>
        );
    }
}

export default AppSteps;
